import instObj from '@/backend/axios-instances'

const resource = "/cutsheets"
const instance = instObj.baseInstance

export default {
  post(data, parameters) {
    //need project_id as a param
    return instance.post(`${resource}/skids`, data, { params: parameters });
  },
  get(parameters) {
    return instance.get(`${resource}/skids`, { params: parameters });
  },
  put(skidId, data, parameters) {
    return instance.put(`${resource}/skid/${skidId}`, data, { params: parameters });
  },
  delete(skidId, parameters) {
    return instance.delete(`${resource}/skid/${skidId}`, { params: parameters });
  }
}